import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    locale: String,
  };

  connect() {
    this.locale =
      this.localeValue || window.location.pathname.split("/")[1].toUpperCase();
  }

  gtagClick(e) {
    const label = e?.params?.label || "";
    const lang = this.locale.length > 2 || !this.locale ? "EN" : this.locale;

    if (label === "appstore") {
      gtag("event", "click_download_app", {
        site_language: lang,
        store: "App Store",
        place: "footer"
      });
      if (typeof rdt === "function") {
              rdt("track", "Custom", { customEventName: "click_download_app" });
            }
    } else if (label === "googleplay") {
      gtag("event", "click_download_app", {
        site_language: lang,
        store: "Google Play",
        place: "footer"
      });
    } else if (label === "click_gpt_chatbot_footer") {
      gtag("event", label, {
        site_language: lang,
      });
      if (typeof rdt === "function") {
              rdt("track", "Custom", { customEventName: label });
            }
    } else if (["instagram", "facebook", "youtube"].includes(label)) {
      gtag("event", "click_social", {
        site_language: lang,
        network: label,
        place: "footer"
      });
      if (typeof rdt === "function") {
              rdt("track", "Custom", { customEventName: "click_social" });
            }
    } else {
      gtag("event", "navigation_click", {
        site_language: lang,
        place: "footer",
        menu_block: label
      });
      if (typeof rdt === "function") {
              rdt("track", "Custom", { customEventName: "navigation_click" });
            }
    }
  }
}
